import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Table as ReactTable,
} from "react-bootstrap";
import { 
  useNavigate, 
  // useParams 
} from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { toastStyle } from "../../Helpers/Utils/Common";
import trash from "./../../Assets/Images/trash.png";
import Select from "react-select";
import { Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

//components
import Table from "../../Components/TableTemplate/Table";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import ViewModal from "../../Components/Modals/ViewModal";
import EditModal from "../../Components/Modals/EditModal";
import InputError from "../../Components/InputError/InputError";

//css
import "./MenuManager.css";

//api
import { refreshPage } from "../../Helpers/Utils/Common";
import {
  createMenuManager,
  deleteMenuManager,
  getAllMenuManager,
  searchMenuManager,
  updateMenuManager,
  getShowMenuManager,
} from "../../Helpers/apiCalls/menuManagerApi";
import { getAllCategories } from "../../Helpers/apiCalls/categoriesManagerApi";
import { getAllRemarks } from "../../Helpers/apiCalls/remarksManagerApi";
import { validateMenu } from "../../Helpers/Validation/Admin/MenuManager";
import { getVAT } from "../../Helpers/apiCalls/MenuApi";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import moment from "moment";
import MytFooter from "../../Components/MytFooter";

export default function MenuManager() {
  // const { id } = useParams();
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [modifierItems, setModifierItems] = useState([]);
  // const [editFile, setEditFile] = useState(false);
  const today = moment(new Date()).format("yyyy-MM-DD");
  // MODALS //

  const [fileList, setFileList] = useState([]);
  const handleUploadChange = (data) => {
    setFileList(data?.fileList);
  }

  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // VIEW
  const [showViewUserModal, setShowViewUserModal] = useState(false);
  const handleShowViewUserModal = () => setShowViewUserModal(true);
  const handleCloseViewUserModal = () => setShowViewUserModal(false);

  const [selectedRow, setSelectedRow] = useState({});
  // EDIT
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const handleShowEditUserModal = () => setShowEditUserModal(true);
  const handleCloseEditUserModal = () => setShowEditUserModal(false);

  // ADD
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const handleShowAddUserModal = () => setShowAddUserModal(true);
  const handleCloseAddUserModal = () => setShowAddUserModal(false);

  //API
  // const [editRemarks, setEditRemarks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [remarks, setRemarks] = useState([]);
  // const [usersData, setUsersData] = useState([]);
  // const [userData, setUserData] = useState({});
  // const [selectedID, setSelectedID] = useState("");
  const [editMenuInfo, setEditMenuInfo] = useState({});
  const [addMenuInfo, setAddMenuInfo] = useState({
    name: "",
    categories: "",
    remarks: "",
    price: "",
    foodpanda_price: "",
    grab_price: "",
    takeout_price: "",
    description: "",
    file: "",
    effective_date: today,
    is_package: "0",
    is_addon: "0",
    with_discount: "0",
    is_dine_in: "0",
    is_take_out: "0",
    is_delivery: "0",
    ref_no: "0",
    suspend_sale: "0",
    ref_name: "0",
    weight: "",
    is_vatable: "1",
    vat_in: "0",
    vat_ex: "0",
    vat_component: "0",
    other_charges: "0",
    qty: "",
    modifiers: [],
    is_modifier: "0",
    with_modifier: "0",
  });

  //-----------------------------------------------------------------
  //PACKAGE
  const [packageDetails, setPackageDetails] = useState([]);

  // const [packageDetailsEdit, setPackageDetailsEdit] = useState([]);
  //ADD
  const addItem = () => {
    const newItem = { name: "", qty: "", unit: "" };
    setPackageDetails((prevItems) => [...prevItems, newItem]);
  };
  const removeItems = (index) => {
    const list = [...packageDetails];
    list.splice(index, 1);
    setPackageDetails(list);
  };

  // const getFrequency = [
  //   { label: "Everyday", value: "everyday" },
  //   { label: "Monday", value: "monday" },
  //   { label: "Tuesday", value: "tuesday" },
  //   { label: "Wednesday", value: "wednesday" },
  //   { label: "Thursday", value: "thursday" },
  //   { label: "Friday", value: "friday" },
  //   { label: "Saturday", value: "saturday" },
  //   { label: "Sunday", value: "sunday" },
  // ];
  
  function handleItemChange(e, index, select) {
    if (select) {
      const { name, value } = e;
      const list = [...packageDetails];
      // list[index][name] = name;
      list[index]["name"] = name;
      list[index]["value"] = value;
      // list[index]["name_value"] = {
      //   value: value, name: name};

      setPackageDetails(list);
    } else {
      const { name, value } = e.target;
      const list = [...packageDetails];
      // list[index]["name"] = name;
      list[index][name] = value;
      setPackageDetails(list);
    }
  }

  function renderTable() {
    return (
      <div className="table-content mt-3">
        <ReactTable>
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Unit</th>
              {packageDetails.length !== 1 && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {packageDetails.map((item, index) => {
              return (
                <tr key={item.id}>
                  <td>
                    <Select
                      className="text-start react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select Item..."
                      options={menuItems}
                      name="id"
                      // id={item.id}
                      defaultValue={item}
                      onChange={(e) => handleItemChange(e, index, true)}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      name="qty"
                      value={item.qty}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="text"
                      name="unit"
                      value={item.unit}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </td>
                  <td>
                    {index !== 0 && (
                      <img
                        src={trash}
                        onClick={() => removeItems(index)}
                        className="cursor-pointer" alt=""
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </ReactTable>
      </div>
    );
  }

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
    effective_date: false,
    default_printer: false,
    categories: false,
    price: false,
    remarks: false,
    description: false,
    file: false,
    is_package: false,
    with_discount: false,
    vat_in: false,
    vat_ex: false,
    vat_component: false,
    other_charges: false,
    item_code: false,
    takeout_price: false,
    qty: false,
  });

  // SEARCH USER
  const [searchUsername, setSearchUsername] = useState("");
  function handleOnSearch(e) {
    searchMenu(e.target.value);
  }
  const [categoryDetails, setCategoryDetails] = useState([]);

  //DROPDOWN
  function handleSelectChange(e, row) {
    setSelectedRow(row);
    
    if (e.target.value === "delete-user") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-user") {
      handleShowEditUserModal();
      fetchShowCategories(row.id);
    } else if (e.target.value === "view-user") {
      handleShowViewUserModal();
      fetchShowCategories(row.id);
    } else if (e.target.value === "inventory") {
      navigate("/inventory/" + row.id);
    } else {
      refreshPage();
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option selected hidden>
          Select
        </option>
        <option value="view-user" className="color-options">
          View
        </option>
        <option value="edit-user" className="color-options">
          Edit
        </option>
        <option value="delete-user" className="color-red">
          Delete
        </option>
        <option value="inventory" className="color-red">
          Inventory
        </option>
      </Form.Select>
    );
  }

  // getAllCategories
  async function fetchCategories() {
    setShowLoader(true);
    const response = await getAllCategories();
    if (response.data) {
      let result = response.data.data.categories.map((data) => {
        return {
          label: data.name,
          value: data.id,
        };
      });
      setCategories(result);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  // getShowCategories
  async function fetchShowCategories(id) {
    setShowLoader(true);
    const response = await getShowMenuManager(id);
    if (response.data) {
      let obj = response.data;
      let new_obj = [];
      let default_modifiers = []
      obj.is_vatable = parseFloat(obj.vat_component) > 0 ? "1" : "0";

      setFileList([
        {
          uid: '-1',
          name: 'prime_logo.png',
          status: 'done',
          url: obj.file_url,
        },
      ])
      if(obj?.menu_categories){
        new_obj = obj?.menu_categories.map((val) => {
          return { label: val.name, value: val.id };
        });
      }
      if(obj.menu_modifiers){
        default_modifiers = obj?.menu_modifiers.map((val) => {
          return val.modifier_id;
        });
      }

      let new_remark = [];
      if (obj.menu_remarks) {
        obj.menu_remarks.map((val) => {
          new_remark.push({ ...val, label: val.remark, value: val.remark_id });
        });
      }

      // setEditMenuInfo({ ...obj, new_obj, menu_remarks: [...new_remark] });
      setEditMenuInfo({ ...obj, new_obj, categories: [...new_obj], menu_remarks: [...new_remark], menu_modifiers: [...default_modifiers],  modifiers: [...default_modifiers] });

    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  const [computedVat, setComputedVat] = useState("0");

  async function fetchVatIn() {
    const response = await getVAT(addMenuInfo);
    if (response.data) {
      setComputedVat(response.data.data);
      setAddMenuInfo((prev) => ({ ...prev, ...response.data.data }));
    }
  }

  async function fetchEditVatIn() {
    const response = await getVAT(editMenuInfo);
    if (response.data) {
      setComputedVat(response.data.data);
      setEditMenuInfo((prev) => ({ ...prev, ...response.data.data }));
    }
  }

  // getAllRemarks
  async function fetchRemarks() {
    setShowLoader(true);
    const response = await getAllRemarks();
    if (response.data) {
      let results = response.data.data.remarks.map((data) => {
        return {
          name: "remarks_id",
          label: data.name,
          value: data.id,
        };
      });
      setRemarks(results);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  // ----------------------------------------------------------------------------------------------------------
  //FETCH API CALL GetAllMenu
  async function fetchMenu() {
    setMenuItems([]);
    setShowLoader(true);
    const response = await getAllMenuManager();
    if (response.data) {
      let categories = response.data.data.all_menus;
      categories.map((item) => {
        item.products.map((info) => {
          info.category_id = item.category_id;
          info.category_name = item.category_name;
          info.value = info.id;
          info.label = info.name;
          info.suspend_sale = info.suspend_sale === "1" ? "SUSPENDED" : "";
          // info.categories = [{label: info.category_name, value: info.category_id}]
          setMenuItems((prev) => [...prev, info]);
        });
      });
      // setMenuItems(categories)
    } else {
      setMenuItems([]);
    }
    setShowLoader(false);
  }

  //FETCH API CALL searchMenuManager
  async function searchMenu(name) {
    setShowLoader(true);
    setMenuItems([]);
    const response = await searchMenuManager(name);
    if (response.data) {
      let categories = response.data.data.menus;
      categories.map((item) => {
        item.products.map((info) => {
          info.category_id = item.category_id;
          info.category_name = item.category_name;
          info.value = info.id;
          info.label = info.name;
          info.categories = [
            { label: info.category_name, value: info.category_id },
          ];
          setMenuItems((prev) => [...prev, info]);
        });
      });
    } else {
      setMenuItems([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  async function searchModifiers() {
    setShowLoader(true);
    // setMenuItems([]);
    const response = await UseGetRequest(
      "menus/search",
      { is_modifier: 1 },
    );
    if (response.data) {
      setModifierItems(response?.data?.menus)
    } else {
      setModifierItems([])
    }
    setShowLoader(false);
  }

  // ----------------------------------------------------------------------------------------------------------

  // Remarks Input Add/Edit Field
  const [inputFields, setInputFields] = useState([
    {
      remarks: "",
    },
  ]);


  //ADD or CREATE USER
  const handleAddOnChange = (e, type) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setAddMenuInfo((prevState) => ({
        ...prevState,
        [name]: files,
      }));
    } else {
      setAddMenuInfo((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleAddChange = (e, type, modifier_id) => {
    if (type === "remarks") {
      setAddMenuInfo((prevState) => ({
        ...prevState,
        remarks: e,
      }));
    } else if(type === "modifiers"){
      if (addMenuInfo?.modifiers.includes(modifier_id)) {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [type]: prevState[type].filter((id) => id !== modifier_id),
        }));
      } else {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [type]: [...prevState[type], modifier_id],
        }));
      }
    } else if (type === "frequency") {
      setAddMenuInfo((prevState) => ({
        ...prevState,
        frequency: e.value,
      }));
    } else if (type === "categories") {
      setAddMenuInfo((prevState) => ({
        ...prevState,
        categories: e,
      }));
    } else {
      const { name, value, files } = e.target;
      if (name === "is_package") {
        if (addMenuInfo.is_package === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_addon") {
        if (addMenuInfo.is_addon === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "with_discount") {
        if (addMenuInfo.with_discount === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_dine_in") {
        if (addMenuInfo.is_dine_in === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_modifier") {
        if (addMenuInfo.is_modifier === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
            with_modifier: "0"
          }));
        }
      } else if (name === "with_modifier") {
        if (addMenuInfo.with_modifier === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_take_out") {
        if (addMenuInfo.is_take_out === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_delivery") {
        if (addMenuInfo.is_delivery === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_vatable") {
        if (addMenuInfo.is_delivery === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "suspend_sale") {
        if (addMenuInfo.suspend_sale === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "ref_name") {
        if (addMenuInfo.ref_name === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_addon") {
        if (addMenuInfo.is_addon === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "ref_no") {
        if (addMenuInfo.ref_no === "ref_no") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "file") {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [name]: files,
        }));
      } else {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  //Create API Menu
  async function createMenu() {
    setIsClicked(true);
    if (validateMenu(addMenuInfo, packageDetails, setIsError)) {
      setIsClicked(true);
      const response = await createMenuManager(
        addMenuInfo,
        packageDetails,
        fileList,
      );
      if (response?.data) {
        toast.success("Successfully Created Menu!", { style: toastStyle() });
        handleCloseAddUserModal();
        refreshPage();
      } else {
        response.error.data.message.map((data) => {
          toast.error(data.item_code, { style: toastStyle() });
        });
        setIsClicked(false);
      }
    } else {
      setIsClicked(false);
    }
  }
  // ----------------------------------------------------------------------------------------------------------
  //EDIT or UPDATE USER

  const handleEditNew = (selectedOptions, fieldName) => {
    if (fieldName === "new_obj") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        categories: selectedOptions,
      }));
    }
    if (fieldName === "menu_remarks") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        menu_remarks: selectedOptions,
      }));
    }
    if (fieldName === "frequency") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        frequency: selectedOptions.value,
      }));
    }
  };

  const handleEditChange = (e, type, modifier_id) => {
    if (type === "remarks") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        remarks: e,
      }));
    } else if(type === "modifiers"){
      if (editMenuInfo?.modifiers.includes(modifier_id)) {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [type]: prevState[type].filter((id) => id !== modifier_id),
        }));
      } else {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [type]: [...prevState[type], modifier_id],
        }));
      }
    } else if (type === "frequency") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        frequency: e.value,
      }));
    } else if (type === "categories") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        categories: e,
      }));
    } else {
      const { name, value, files } = e.target;
      if (name === "is_package") {
        if (editMenuInfo.is_package === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_addon") {
        if (editMenuInfo.is_addon === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "with_discount") {
        if (editMenuInfo.with_discount === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_dine_in") {
        if (editMenuInfo.is_dine_in === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_modifier") {
        if (editMenuInfo.is_modifier === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
            with_modifier: "0"
          }));
        }
      } else if (name === "with_modifier") {
        if (editMenuInfo.with_modifier === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_take_out") {
        if (editMenuInfo.is_take_out === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_delivery") {
        if (editMenuInfo.is_delivery === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_vatable") {
        if (editMenuInfo.is_delivery === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "suspend_sale") {
        if (editMenuInfo.suspend_sale === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "ref_name") {
        if (editMenuInfo.ref_name === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_addon") {
        if (editMenuInfo.is_addon === "1") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "ref_no") {
        if (editMenuInfo.ref_no === "ref_no") {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "file") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: files,
        }));
      } else {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };
  
  async function updateMenu() {
    setIsClicked(true);
    if (validateMenu(editMenuInfo, packageDetails, setIsError)) {
      setIsClicked(true);
      const response = await updateMenuManager(
        editMenuInfo,
        packageDetails,
        fileList,
      );

      if (response.data) {
        toast.success("Successfully Updated Menu!", { style: toastStyle() });
        handleCloseEditUserModal();
        refreshPage();
      } else {
        toast.error("Error Updating New Menu", { style: toastStyle() });
        setIsClicked(false);
      }
    } else {
      setIsClicked(false);
    }
  }

  //onEdit
  function handleOnEdit() {
    handleCloseViewUserModal();
    handleShowEditUserModal();
  }
  // ----------------------------------------------------------------------------------------------------------
  //DELETE or REMOVE MENU
  async function handleDeleteMenu() {
    const response = await deleteMenuManager(selectedRow.id);
    if (response.data) {
      toast.success("Successfully Deleted Menu!", { style: toastStyle() });
      handleCloseDeleteModal();
      refreshPage();
    } else {
      toast.error(response.error.data.messages.error, { style: toastStyle() });
    }
  }
  
  const handleIsVatable = (e) => {
    const { name, checked } = e.target;
    setAddMenuInfo((prevState) => ({
      ...prevState,
      is_vatable: checked,
    }));
    setAddMenuInfo((prevState) => ({
      ...prevState,
      vat_component: checked ? "0" : editMenuInfo.vat_component,
    }));
  };
  // const handleIsVatableEdit = (e) => {
  //   const { name, checked } = e.target;
  //   setEditMenuInfo((prevState) => ({
  //     ...prevState,
  //     is_vatable: checked,
  //   }));
  //   setEditMenuInfo((prevState) => ({
  //     ...prevState,
  //     vat_component: checked ? "0" : editMenuInfo.vat_component,
  //   }));
  // };
  useEffect(() => {
    fetchMenu();
    fetchCategories();
    fetchRemarks();
  }, [showAddUserModal, showEditUserModal]);

  useEffect(() => {
    if(showAddUserModal || showEditUserModal){
      searchModifiers();
    }
  }, [showAddUserModal, showEditUserModal]);

  useEffect(() => {
    fetchVatIn();
  }, [addMenuInfo.price, addMenuInfo.is_vatable]);

  useEffect(() => {
    fetchEditVatIn();
  }, [editMenuInfo.price, editMenuInfo.is_vatable]);
  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Menus"}
          page={"Menus"}
        />
      </div>
      <div className={`container ps-4 pt-4 ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={8}>
            <h1 className="page-title-menu"> MENU MANAGER </h1>
          </Col>
          <Col xs={3} className="mt-1 d-flex justify-content-end">
            <div class="search-container">
              <input
                type="text"
                class="search-input"
                placeholder="Search menu..."
                name="or_no"
                onKeyPress={(e) =>
                  e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
                }
                onChange={(e) => handleOnSearch(e)}
              />
              <i class="search-icon">&#128269;</i>
            </div>
          </Col>
          <Col xs={1} className="center">
            <button className="add-btn-menu" onClick={handleShowAddUserModal}>
              Add
            </button>
          </Col>
        </Row>

        <div className="table-content mb-5">
          {/* TABLE */}
          <Table
            tableHeaders={[
              "CATEGORIES",
              "NAME",
              // "FILE",
              "PRICE",
              "FOOD PANDA PRICE",
              "GRAB PRICE",
              // "QUANTITY",
              // "REMARK",
              "ACTIONS",
            ]}
            headerSelector={[
              "category_name",
              "name",
              // "file_url",
              "price",
              "foodpanda_price",
              "grab_price",
              // "qty",
              // "suspend_sale",
            ]}
            tableData={menuItems}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
        <MytFooter/>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="menu"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteMenu}
      />
  
      <AddModal
        title="MENU"
        type="user"
        show={showAddUserModal}
        // loader={isClicked}
        onHide={handleCloseAddUserModal}
        onSave={createMenu}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col>
              NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError isValid={isError.name} message={"Name is required"} />
            </Col>
            <Col>
              EFFECTIVE DATE
              <span className="required"> * </span>
              <Form.Control
                type="date"
                name="effective_date"
                className="nc-modal-custom-input"
                value={addMenuInfo.effective_date}
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.effective_date}
                message={"Effective date is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              CATEGORY
              {
                addMenuInfo?.is_modifier === "0" && (
                  <span className="required">*</span>
                )
              }
              <Select
                className="text-start react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Category..."
                options={categories}
                name="categories"
                isMulti
                onChange={(e) => handleAddChange(e, "categories")}
              />
              <InputError
                isValid={isError.categories}
                message={"Menu Category is required"}
              />
            </Col>
            <Col>
              ITEM CODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="item_code"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.item_code}
                message={"Item Code is required"}
              />
            </Col>
            <Col>
              DEFAULT PRINTER
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="default_printer"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.default_printer}
                message={"Default Printer is required"}
              />
            </Col>
            {/* <Col xl={6}>
              REMARKS
                <Select 
                  name="remarks"
                  classNamePrefix='react-select'
                  placeholder='Select Remarks...'
                  className="text-start react-select-container"
                  options={remarks}
                  onChange={(e)=>handleAddChange(e, 'remarks')}
                  isMulti
                    required
                  />
                <InputError
                  isValid={isError.remarks}
                  message={"Remarks is Required"}
              />
            </Col> */}
          </Row>
          <Row className="nc-modal-custom-row">
            {/* <Col> */}
            <Col>
              STORE PRICE
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="price"
                min={0}
                value={addMenuInfo.price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.price}
                message={"Price is required"}
              />
            </Col>
            <Col>
              TAKEOUT PRICE
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="takeout_price"
                min={0}
                value={addMenuInfo.takeout_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.takeout_price}
                message={"Takeout Price is required"}
              />
            </Col>
            <Col>
              FOOD PANDA PRICE
              {/* <span className="required" > * </span> */}
              <Form.Control
                type="number"
                name="foodpanda_price"
                min={0}
                value={addMenuInfo.foodpanda_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
            </Col>
            <Col>
              GRAB PRICE
              {/* <span className="required" > * </span> */}
              <Form.Control
                type="number"
                name="grab_price"
                min={0}
                value={addMenuInfo.grab_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
            </Col>
            {/* <Col>
                DESCRIPTION
                <span className="required"> * </span>
                <Form.Control
                  type="text"
                  name="description"
                  className="nc-modal-custom-input"
                  onChange={(e) => handleAddOnChange(e)}
                  required
                />
              <InputError
                isValid={isError.description}
                message={"Description is required"}
              /> 
              </Col>*/}
            {/* <Col>
                QUANTITY
                <span className="required" > * </span>
                <Form.Control
                  type="number"
                  name="qty"
                  min={0}
                  className="nc-modal-custom-input"
                  onChange={(e) => handleAddOnChange(e)}
                  required
                />
                <InputError
                isValid={isError.qty}
                message={"Quantity is required"}
              />
              </Col> */}
          </Row>
          {/* <Row className="nc-modal-custom-row">
              <Col>
                FREQUENCY
                  <Select 
                    name="frequency"
                    classNamePrefix='react-select'
                    placeholder='Select Frequency...'
                    className="text-start react-select-container"
                    options={getFrequency}
                    onChange={(e)=>handleAddChange(e, 'frequency')}
                    required
                  />
                  <InputError
                    isValid={isError.frequency}
                    message={"Frequency is Required"}
                />
              </Col>
              <Col>
                REORDER POINT
                <Form.Control
                  type="number"
                  name="reorder_point"
                  min={0}
                  className="nc-modal-custom-input"
                  onChange={(e) => handleAddOnChange(e)}
                  required
                />
              </Col>
              <Col>
                REORDER QUANTITY
                <Form.Control
                  type="number"
                  name="reorder_qty"
                  min={0}
                  className="nc-modal-custom-input"
                  onChange={(e) => handleAddOnChange(e)}
                />
              </Col>
            </Row> */}
          {/* <Row className="nc-modal-custom-row">
              <Col>
                FILE
                <span className="required"> * </span>
                <Form.Control
                  type="file"
                  name="file"
                  // value={addMenuInfo.file}
                  className="nc-modal-custom-input"
                  onChange={(e) => handleAddOnChange(e)}
                  required
                />
                <InputError
                isValid={isError.file}
                message={"File is required"}
              />
              </Col> 
            </Row> */}
          <Row className="nc-modal-custom-row">
            {/* <Col>
              <div>
                <input id="is_vatable" class="checkbox-custom" name="is_vatable" type="checkbox" onChange={(e) => handleIsVatable(e)}/>
                <label for="is_vatable" class="checkbox-custom-label">Non-VAT</label>
              </div>                
              </Col> */}
            <Col>
              VAT In
              <Form.Control
                type="number"
                name="vat_in"
                min={0}
                disabled
                value={addMenuInfo.price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.vat_in}
                message={"Vat In is required"}
              />
            </Col>
            <Col>
              VAT Ex
              <Form.Control
                type="number"
                name="vat_ex"
                disabled
                value={addMenuInfo.vat_ex}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              VAT COMPONENT
              <Form.Control
                type="text"
                name="vat_component"
                disabled
                value={addMenuInfo.vat_component}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              OTHER CHARGES
              <Form.Control
                type="text"
                name="other_charges"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="my-4">
            <Col xs={12}>
              <Upload
                listType="picture-card"
                fileList={fileList}
                onChange={handleUploadChange}
                itemRender={(originNode, file, currFileList, actions) => {
                  const hasUrl = !!file.url;
                  return (
                    <div className="custom-upload-item">
                      <div style={{ pointerEvents: hasUrl ? "auto" : "none" }}>
                        {originNode.props.children}
                      </div>
                      <div className="custom-delete-button" onClick={() => actions.remove()}>
                        Delete
                      </div>
                    </div>
                  );
                }}
              >
                {fileList.length >= 1 ? null : (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                )}
              </Upload>
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            {/* <Col xs="4">
              TYPE
              <div>
                <input id="is_package" class="checkbox-custom" name="is_package" type="checkbox" onChange={(e) => handleAddChange(e)} value="1"/>
                <label for="is_package" class="checkbox-custom-label">PACKAGE</label>
              </div>
              <div>
                <input id="is_addon" class="checkbox-custom" name="is_addon" type="checkbox" onChange={(e) => handleAddChange(e)} value="1"/>
                <label for="is_addon" class="checkbox-custom-label">ADD ONS</label>   
              </div>
              </Col> */}
            <Col xs="4">
              AVAILABLE FOR:
              <div>
                <input
                  id="is_vatable"
                  class="checkbox-custom"
                  name="is_vatable"
                  type="checkbox"
                  onChange={(e) => handleIsVatable(e)}
                />
                <label for="is_vatable" class="checkbox-custom-label">
                  Non-VAT
                </label>
              </div>
              <div>
                <input
                  id="with_discount"
                  class="checkbox-custom"
                  name="with_discount"
                  type="checkbox"
                  onChange={(e) => handleAddChange(e)}
                  value="1"
                />
                <label for="with_discount" class="checkbox-custom-label">
                  WITH DISCOUNT
                </label>
              </div>
              <div>
                <input
                  id="suspend_sale"
                  class="checkbox-custom"
                  name="suspend_sale"
                  type="checkbox"
                  onChange={(e) => handleAddChange(e)}
                  value="1"
                />
                <label for="suspend_sale" class="checkbox-custom-label">
                  SUSPEND SALE
                </label>
              </div>
              <div>
                <input
                  id="is_modifier"
                  class="checkbox-custom"
                  name="is_modifier"
                  type="checkbox"
                  onChange={(e) => handleAddChange(e)}
                  value="1"
                />
                <label for="is_modifier" class="checkbox-custom-label">
                  IS MODIFIER
                </label>
              </div>
              {
                addMenuInfo?.is_modifier === "0" && (
                  <div>
                    <input
                      id="with_modifier"
                      class="checkbox-custom"
                      name="with_modifier"
                      type="checkbox"
                      disabled={addMenuInfo?.is_modifier === "1"}
                      onChange={(e) => handleAddChange(e)}
                      value="1"
                    />
                    <label for="with_modifier" class="checkbox-custom-label">
                      WITH MODIFIER
                    </label>
                  </div>
                )
              }
            </Col>
            <Col xs="8">
              {
                addMenuInfo?.with_modifier === "1" && (
                  <>
                    <Row>MODIFIERS:</Row>
                    <Row>
                      {
                        modifierItems?.map((data) => (
                          <Col xs="4">
                            <input
                              id={data?.menu_item_name}
                              class="checkbox-custom"
                              name={data?.menu_item_name}
                              type="checkbox"
                              onChange={(e) => handleAddChange(e, "modifiers", data?.menu_id)}
                            />
                            <label for={data?.menu_item_name} class="checkbox-custom-label">
                              {data?.menu_item_name?.toUpperCase()}
                            </label>
                          </Col>
                        ))
                      }
                    </Row>
                  </>
                )
              }
            </Col>
          </Row>
          {addMenuInfo.is_package !== "0" && (
            <Row className="nc-modal-custom-row">
              <Col>
                PACKAGE DETAILS
                <span className="required"> * </span>
                <div className="edit-purchased-items">
                  {/* {packageDetails.length === 0 ? (
                    <span>No Package Details Found!</span>
                  ) : (
                    renderTable()
                  )} */}
                  {renderTable()}
                  <InputError
                    isValid={isError.is_package}
                    message={"Fill out all inputs for package detail fields"}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <button className="add-item" onClick={() => addItem()}>
                    Add Item
                  </button>
                </div>
              </Col>
            </Row>
          )}
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="MENU"
        type="menu"
        show={showEditUserModal}
        onHide={handleCloseEditUserModal}
        onSave={updateMenu}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col>
              NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                value={editMenuInfo.name}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError isValid={isError.name} message={"Name is required"} />
            </Col>
            <Col>
              EFFECTIVE DATE
              <span className="required"> * </span>
              <Form.Control
                type="date"
                name="effective_date"
                value={editMenuInfo.effective_date}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.effective_date}
                message={"Effective date is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              CATEGORY
              {
                editMenuInfo?.is_modifier === "0" && (
                  <span className="required">*</span>
                )
              }
              <Select
                className="text-start react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Category..."
                options={categories}
                name="menu_categories"
                isMulti
                value={editMenuInfo.categories}
                onChange={(e) => handleEditNew(e, "new_obj")}
              />
              <InputError
                isValid={isError.new_obj}
                message={"Menu Category is required"}
              />
            </Col>
            <Col>
              ITEM CODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="item_code"
                className="nc-modal-custom-input"
                value={editMenuInfo.item_code}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.item_code}
                message={"Item Code is required"}
              />
            </Col>
            <Col>
              DEFAULT PRINTER
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="default_printer"
                className="nc-modal-custom-input"
                value={editMenuInfo.default_printer}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.default_printer}
                message={"Default Printer is required"}
              />
            </Col>
            {/* <Col xl={6}>
                REMARKS
                  <Select 
                    name="remarks"
                    classNamePrefix='react-select'
                    placeholder='Select Remarks...'
                    className="text-start react-select-container"
                    options={remarks}
                    value={editMenuInfo.menu_remarks}
                    onChange={(e)=>handleEditNew(e, 'menu_remarks')}
                    isMulti
                    required
                    />
                  <InputError
                    isValid={isError.remarks}
                    message={"Remarks is Required"}
                />
              </Col> */}
          </Row>
          <Row className="nc-modal-custom-row">
            {/* <Col> */}
            <Col>
              STORE PRICE
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="price"
                min={0}
                value={editMenuInfo.price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.price}
                message={"Price is required"}
              />
            </Col>
            <Col>
              TAKEOUT PRICE
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="takeout_price"
                min={0}
                value={editMenuInfo.takeout_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.takeout_price}
                message={"Takeout Price is required"}
              />
            </Col>
            <Col>
              FOOD PANDA PRICE
              {/* <span className="required" > * </span> */}
              <Form.Control
                type="number"
                name="foodpanda_price"
                min={0}
                value={editMenuInfo.foodpanda_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            <Col>
              GRAB PRICE
              {/* <span className="required" > * </span> */}
              <Form.Control
                type="number"
                name="grab_price"
                min={0}
                value={editMenuInfo.grab_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            {/* <Col>
                DESCRIPTION
                <span className="required"> * </span>
                <Form.Control
                  type="text"
                  name="description"
                  className="nc-modal-custom-input"
                  value={editMenuInfo.description}
                  onChange={(e) => handleEditChange(e)}
                  required
                />
              <InputError
                isValid={isError.description}
                message={"Description is required"}
              />
              </Col> */}
            {/* <Col>
                QUANTITY
                <span className="required" > * </span>
                <Form.Control
                  type="number"
                  name="qty"
                  min={0}
                  className="nc-modal-custom-input"
                  value={editMenuInfo.qty}
                  onChange={(e) => handleEditChange(e)}
                  required
                />
                <InputError
                isValid={isError.qty}
                message={"Quantity is required"}
              />
              </Col> */}
          </Row>
          {/* <Row className="nc-modal-custom-row">
              <Col>
                FREQUENCY
                  <Select 
                    name="frequency"
                    classNamePrefix='react-select'
                    className="text-start react-select-container"
                    options={getFrequency}
                    value={getFrequency.find(option => option.value === editMenuInfo.frequency)}
                    onChange={(selectedOption)=>handleEditNew(selectedOption, 'frequency')}
                    required
                  />
                  <InputError
                    isValid={isError.frequency}
                    message={"Frequency is Required"}
                />
              </Col>
              <Col>
                REORDER POINT
                <Form.Control
                  type="number"
                  name="reorder_point"
                  min={0}
                  className="nc-modal-custom-input"
                  value={editMenuInfo.reorder_point}
                  onChange={(e) => handleEditChange(e)}
                  required
                />
              </Col>
              <Col>
                REORDER QUANTITY
                <Form.Control
                  type="number"
                  name="reorder_qty"
                  min={0}
                  className="nc-modal-custom-input"
                  value={editMenuInfo.reorder_qty}
                  onChange={(e) => handleEditChange(e)}
                />
              </Col>
            </Row> */}
          {/* <Row className="nc-modal-custom-row">
              <Col>
                FILE
                {!editFile && (
                  <div className="row">

                      <span className="file-name-details">{editMenuInfo.file_url}</span>
              
                    <div className="col">
                      <button className="delete-file-btn" onClick={() => setEditFile(!editFile)}>✖</button>
                    </div>
                  </div>
                )}
                {editFile && (
                  <Form.Control
                  type="file"
                  name="file"
                  // value={editMenuInfo.file}
                  // defaultValue={selectedRow.file} 
                  className="nc-modal-custom-input-edit"
                  onChange={(e) => handleEditChange(e)}
                />
                )}
              </Col>
            </Row> */}
          <Row className="nc-modal-custom-row">
            {/* <Col>
              <div>
                <input id="is_vatable" class="checkbox-custom" name="is_vatable" type="checkbox" onChange={(e) => handleIsVatableEdit(e)}/>
                <label for="is_vatable" class="checkbox-custom-label">Non-VAT</label>
              </div>                
              </Col> */}
            <Col>
              VAT In
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="vat_in"
                min={0}
                disabled
                className="nc-modal-custom-input"
                value={editMenuInfo.price}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.vat_in}
                message={"Vat In is required"}
              />
            </Col>
            <Col>
              VAT Ex
              <Form.Control
                type="number"
                name="vat_ex"
                disabled
                value={editMenuInfo.vat_ex}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              VAT COMPONENT
              <Form.Control
                type="text"
                name="vat_component"
                disabled
                value={editMenuInfo.vat_component}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              OTHER CHARGES
              <Form.Control
                type="text"
                name="other_charges"
                className="nc-modal-custom-input"
                value={editMenuInfo.other_charges}
                onChange={(e) => handleEditChange(e)}
              />
            </Col>
          </Row>
          <Row className="my-4">
            <Col xs={12}>
              <Upload
                listType="picture-card"
                fileList={fileList}
                onChange={handleUploadChange}
                itemRender={(originNode, file, currFileList, actions) => {
                  const hasUrl = !!file.url;
                  return (
                    <div className="custom-upload-item">
                      <div style={{ pointerEvents: hasUrl ? "auto" : "none" }}>
                        {originNode.props.children}
                      </div>
                      <div className="custom-delete-button" onClick={() => actions.remove()}>
                        Delete
                      </div>
                    </div>
                  );
                }}
              >
                {fileList.length >= 1 ? null : (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                )}
              </Upload>
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            {/* <Col xs="4">
              TYPE
              <div>
                <input id="is_package" class="checkbox-custom" name="is_package" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_package === "0"? false:true}/>
                <label for="is_package" class="checkbox-custom-label">PACKAGE</label>
              </div>
              <div>
                <input id="is_addon" class="checkbox-custom" name="is_addon" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_addon === "1"? true:false}/>
                <label for="is_addon" class="checkbox-custom-label">ADD ONS</label>   
              </div>
              </Col> */}
            <Col xs="4">
              AVAILABLE FOR:
              <div>
                <input
                  id="is_vatable"
                  class="checkbox-custom"
                  name="is_vatable"
                  type="checkbox"
                  onChange={(e) => setEditMenuInfo((prevState) => ({
                    ...prevState,
                    is_vatable: e.target.checked?"0":"1",
                  }))}
                  checked={
                    editMenuInfo.is_vatable === "1" ? false : true
                  }                />
                <label for="is_vatable" class="checkbox-custom-label">
                  Non-VAT
                </label>
              </div>
              <div>
                <input
                  id="with_discount"
                  class="checkbox-custom"
                  name="with_discount"
                  type="checkbox"
                  onChange={(e) => handleEditChange(e)}
                  checked={editMenuInfo.with_discount === "0" ? false : true}
                />
                <label for="with_discount" class="checkbox-custom-label">
                  WITH DISCOUNT
                </label>
              </div>
              <div>
                <input
                  id="suspend_sale"
                  class="checkbox-custom"
                  name="suspend_sale"
                  type="checkbox"
                  onChange={(e) => handleEditChange(e)}
                  checked={editMenuInfo.suspend_sale === "0" ? false : true}
                />
                <label for="suspend_sale" class="checkbox-custom-label">
                  SUSPEND SALE
                </label>
              </div>
              <div>
                <input
                  id="is_modifier"
                  class="checkbox-custom"
                  name="is_modifier"
                  type="checkbox"
                  onChange={(e) => handleEditChange(e)}
                  checked={editMenuInfo.is_modifier === "0" ? false : true}
                />
                <label for="is_modifier" class="checkbox-custom-label">
                  IS MODIFIER
                </label>
              </div>
              {
                editMenuInfo?.is_modifier === "0" && (
                  <div>
                    <input
                      id="with_modifier"
                      class="checkbox-custom"
                      name="with_modifier"
                      type="checkbox"
                      disabled={editMenuInfo?.is_modifier === "1"}
                      onChange={(e) => handleEditChange(e)}
                      checked={editMenuInfo.with_modifier === "0" ? false : true}
                    />
                    <label for="with_modifier" class="checkbox-custom-label">
                      WITH MODIFIER
                    </label>
                  </div>
                )
              }
              {/* <div>
                <input id="is_dine_in" class="checkbox-custom" name="is_dine_in" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_dine_in === "0"? false:true}/>
                <label for="is_dine_in" class="checkbox-custom-label">DINE-IN</label>
              </div>
              <div>
                <input id="is_take_out" class="checkbox-custom" name="is_take_out" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_take_out === "0"? false:true}/>
                <label for="is_take_out" class="checkbox-custom-label">TAKE-OUT</label>
              </div>
              <div>
                <input id="is_delivery" class="checkbox-custom" name="is_delivery" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_delivery === "0"? false:true}/>
                <label for="is_delivery" class="checkbox-custom-label">DELIVERY</label>
              </div> */}
            </Col>
            <Col xs="8">
              {/* <div>
                <input id="with_discount" class="checkbox-custom" name="with_discount" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.with_discount === "0"? false:true}/>
                <label for="with_discount" class="checkbox-custom-label">WITH DISCOUNT</label>
              </div> */}
              {/* <div>
                  <input id="is_addon" class="checkbox-custom" name="is_addon" type="checkbox" onClick={()=> setByWeight(!byWeight)} onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_addon === "0"? false:true}/>
                  <label for="is_addon" class="checkbox-custom-label">IS ADDON</label>
                </div> */}
              {/* <div>
                <input id="suspend_sale" class="checkbox-custom" name="suspend_sale" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.suspend_sale === "0"? false:true}/>
                <label for="suspend_sale" class="checkbox-custom-label">SUSPEND SALE</label>
              </div> */}
              {/* <div>
                <input id="checkbox-1" class="checkbox-custom" name="is_package" type="checkbox" onChange={(e) => handleAddChange(e)}/>
                <label for="checkbox-1" class="checkbox-custom-label">COMPUTE PRICE FROM GROSS</label>
              </div> */}
              {/* <div>
                <input id="ref_name" class="checkbox-custom" name="ref_name" type="checkbox" onChange={(e) => handleEditChange(e)} checked={editMenuInfo.ref_name === "0"? false:true}/>
                <label for="ref_name" class="checkbox-custom-label">SHOW ON QUICK MENU</label>
              </div> */}
              {/* <Col >
                <div>
                  <input id="is_addon" class="checkbox-custom" name="is_addon" type="checkbox" onClick={()=> setByWeight(!byWeight)} onChange={(e) => handleEditChange(e)} checked={editMenuInfo.is_addon === "0"? false:true}/>
                  <label for="is_addon" class="checkbox-custom-label">SOLD BY WEIGHT</label>
                </div>
              </Col> */}
              {/* {!byWeight &&
              <Col xs="6">
                <div>
                    <Form.Control
                      type="number"
                      name="weight"
                      // value={value}
                      placeholder="1kl"
                      value={editMenuInfo.weight}
                      className="nc-modal-custom-input"
                      onChange={(e) => handleEditChange(e)}
                      // onChange={handleChangeValidPrce}
                      
                    />                
                </div>
              </Col>
              } */}
              {
                editMenuInfo?.with_modifier === "1" && (
                  <>
                    <Row>MODIFIERS:</Row>
                    <Row>
                      {
                        modifierItems?.map((data) => (
                          <Col xs="4">
                            <input
                              id={data?.menu_item_name}
                              class="checkbox-custom"
                              name={data?.menu_item_name}
                              type="checkbox"
                              onChange={(e) => handleEditChange(e, "modifiers", data?.menu_id)}
                              checked={editMenuInfo?.modifiers.includes(data.menu_id)}
                            />
                            <label for={data?.menu_item_name} class="checkbox-custom-label">
                              {data?.menu_item_name?.toUpperCase()}
                            </label>
                          </Col>
                        ))
                      }
                    </Row>
                  </>
                )
              }
            </Col>
          </Row>
          {editMenuInfo.is_package !== "0" && (
            <Row className="nc-modal-custom-row">
              <Col>
                PACKAGE DETAILS
                <span className="required"> * </span>
                <div className="edit-purchased-items">
                  {/* {packageDetails.length === 0 ? (
                    <span>No Package Details Found!</span>
                  ) : (
                    renderTable()
                  )} */}
                  {renderTable()}
                  <InputError
                    isValid={isError.is_package}
                    message={"Fill out all inputs for package detail fields"}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <button className="add-item" onClick={() => addItem()}>
                    Add Item
                  </button>
                </div>
              </Col>
            </Row>
          )}
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewUserModal}
        onHide={handleCloseViewUserModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              MENU DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col>
                  CATEGORY
                  <Row className="nc-modal-custom-row">
                    <Col> {selectedRow.category_name} </Col>
                  </Row>
                </Col>
                <Col>
                  NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {selectedRow.name} </Col>
                  </Row>
                </Col>
                {/* <Col >
                    FILE
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.file} </Col>
                    </Row>
                  </Col> */}
                <Col>
                  PRICE
                  <Row className="nc-modal-custom-row">
                    <Col className="d-flex justify-content-center">
                      {" "}
                      {selectedRow.price}{" "}
                    </Col>
                  </Row>
                </Col>
                {/* <Col lg={2}>
                    DESCRIPTION
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.description} </Col>
                    </Row>
                  </Col>
                  <Col lg={2}>
                    REMARKS
                    <Row className="nc-modal-custom-row">
                    </Row>
                  </Col> */}
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
    </div>
  );
}
